import React from 'react'
import HomePage from './components/HomePage'

const App = () => {
  return (
    <div className='App'>
        <HomePage/>
    </div>
  )
}

export default App
